<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>{{$route.meta.title}}</h3>

      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="true">
      <span slot="header">搜索</span>

      <el-form :model="search"
               :rules="searchRules"
               ref="searchForm"
               label-width="110px"
               label-position="right"
               size="medium"
               class="layout-search-form medium"
               @submit.native.prevent="onSearch()">
        <el-row :gutter="20">
          <el-col>
            <el-form-item label="门店ID："
                          prop="market_id">
              <el-input v-model.number="search.market_id"
                        clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col>
            <el-form-item label="信息收集状态："
                          prop="gatherinfo_status">
              <el-select v-model="search.gatherinfo_status">
                <el-option v-for="item in options.status"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col>
            <el-form-item label="省份："
                          prop="province_id">
              <el-select
                v-model="search.province_id"
                @change="onChangeProvince"
                :loading="inLoading.province"
                clearable>
                <el-option v-for="item in options.province"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col>
            <el-form-item label="城市："
                          prop="city_id">
              <el-select
                v-model="search.city_id"
                @change="onChangeCity"
                :loading="inLoading.city"
                :disabled="!search.province_id"
                clearable>
                <el-option v-for="item in options.city"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col>
            <el-form-item label="地区："
                          prop="area_id">
              <el-select
                v-model="search.area_id"
                :loading="inLoading.area"
                :disabled="!search.province_id || !search.city_id"
                clearable>
                <el-option v-for="item in options.area"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col>
            <el-form-item label="收集结果"
                          prop="gatherinfo_need_export">
              <el-select v-model="search.gatherinfo_need_export" clearable>
                <el-option v-for="item in options.result"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col>
            <el-form-item prop="update_start"
                          label="开启收集时间:">
               <el-date-picker
                v-model="search.update_start"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="center"
                class="width-max">
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col>
            <el-form-item prop="update_end"
                          label="完成收集时间:">
               <el-date-picker
                v-model="search.update_end"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="center"
                class="width-max">
              </el-date-picker>
            </el-form-item>
          </el-col>

         </el-row>

        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <!-- <el-button @click="resetSearch()">重置</el-button> -->
          <el-button @click="onExportSearch()"
                     :disabled="search.gatherinfo_need_export === 0">导出
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>

    <!-- <layout-panel :show-header="false"
                  class="table-panel">
      <el-button type="primary"
                 size="mini"
                 @click="onExportSearch()">搜索结果导出
      </el-button>
    </layout-panel> -->

    <layout-panel :show-header="false">
      <el-table ref="multipleTable"
                :data="table"
                stripe
                highlight-current-row>
        <el-table-column prop="market_id"
                         label="门店ID"></el-table-column>

        <el-table-column prop="marketname"
                         label="卖场名称"></el-table-column>

        <el-table-column prop="province_name"
                         label="省市区">
          <template slot-scope="scope">
            <span>{{scope.row.province_name}}-{{scope.row.city_name}}-{{scope.row.area_name}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="gatherinfo_times"
                         label="收集次数"></el-table-column>
        <el-table-column prop="gatherinfo_status"
                         label="信息收集状态">
          <template slot-scope="scope">
            <span>{{maps.status[scope.row.gatherinfo_status] || '-'}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="gatherinfo_count"
                         label="收集工单数"></el-table-column>
        <el-table-column prop="last_gatherinfo_start" label="开始收集时间" />

        <el-table-column prop="last_gatherinfo_at"
                         label="完成收集时间" />
        <el-table-column prop="gatherinfo_need_export"
                         label="收集结果">
          <template slot-scope="scope">
            <span>{{scope.row.gatherinfo_status * 1 === 4 ? maps.result[scope.row.gatherinfo_need_export] : '-'}}</span>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>


<script>
import table from '@core/mixins/table'



export default {
  mixins: [table],
  data () {
    return {
      search: {
        market_id: '',
        gatherinfo_status: '',
        gatherinfo_need_export: null,
        gatherinfo_times: '',
        update_start: [],
        update_end: [],
        province_id: '',
        city_id: '',
        area_id: '',
      },
      searchRules: {
        market_id: [
          {validator: this.positiveIntegerValidator, trigger: 'blur'},
        ],
        update_end: [
          {validator: this.updateEndValidator, trigger: 'blur'},
        ],
      },
      searchFieldType: {
        market_id: Number,
        gatherinfo_status: Number,
        gatherinfo_need_export: Number,
      },
      inLoading: {
        province: false,
        city: false,
        area: false,
      },

      options: {
        status: [
          {label: '全部', value: ''},
          {label: '不收集', value: 1},
          {label: '待收集', value: 2},
          {label: '收集中', value: 3},
          {label: '收集完成', value: 4},
          {label: '信息确认', value: 5},
        ],
        province: [],
        city: [],
        area: [],
        result: [
          {label: '正常', value: 0},
          {label: '不一致', value: 1},
        ],
      },
      maps: {
        status: {
          '1': '不收集',
          '2': '待收集',
          '3': '收集中',
          '4': '收集完成',
          '5': '信息确认',
        },
        result: {
          '0': '正常',
          '1': '不一致',
        },
      },
    }
  },
  created () {
    this.inLoading.province = true

    request.page('getProvinceList').then(({data}) => {
      this.options.province = data
      this.inLoading.province = false
    }).catch(() => {
      this.inLoading.province = false
    })

    if (this.$route.query.province_id) {
      this.inLoading.city = true

      request.page('getCityList', this.$route.query.province_id).then(({data}) => {
        this.options.city = data
        this.inLoading.city = false
      }).catch(() => {
        this.options.city = []
        this.inLoading.city = false
      })
    }

    if (this.$route.query.city_id) {
      this.inLoading.area = true

      request.page('getAreaList', this.$route.query.city_id).then(({data}) => {
        this.options.area = data
        this.inLoading.area = false
      }).catch(() => {
        this.options.area = []
        this.inLoading.area = false
      })
    }
  },



  methods: {
    getTableData (params) {
      return request.page('getStoreCollectionTable', params)
    },


    updateEndValidator (rule, value, callback) {
      if (Date.parse(this.search.update_end) <= Date.parse(this.search.update_start)) {
        callback(new Error('更新结束时间必须晚于更新开始时间'))
      } else {
        callback()
      }
    },


    onChangeProvince (val) {
      this.search.city_id = ''
      this.search.area_id = ''

      if (val) {
        this.inLoading.city = true

        request.alert('getCityList', val).then(({data}) => {
          this.options.city = data
          this.inLoading.city = false
        }).catch(() => {
          this.options.city = []
          this.inLoading.city = false
        })
      } else {
        this.options.city = []
      }
    },


    onChangeCity (val) {
      this.search.area_id = ''

      if (val) {
        this.inLoading.area = true

        request.alert('getAreaList', val).then(({data}) => {
          this.options.area = data
          this.inLoading.area = false
        }).catch(() => {
          this.options.area = []
          this.inLoading.area = false
        })
      } else {
        this.options.area = []
      }
    },


    // 验证正整数输入
    positiveIntegerValidator (rule, value, callback) {
      if (value && !Number.isInteger(value)) {
        callback(new Error('请输入正整数'))
      } else {
        callback()
      }
    },


    onExportSearch () {
      this.$export(this.$route.meta.title, {
        type: 'array',
        request: (params) => request('exportStoreCollectionTable', {...this.search, ...params}),
        getResponseData (data) {
          // 导出大于一页时去掉标题行
          data.current_page > 1 && data.data.splice(0, 1)
          return data
        },
      })
    },
  },
}
</script>


<style lang="scss"
       scoped
       src="../../platform-user/style/PlatformUser.scss"></style>



// WEBPACK FOOTER //
// src/views/store-collection/pages/StoreCollectionTable.vue